import { examDetailsActionTypes } from './Constants';

export function getExamDetails(data) {
	return {
		type: examDetailsActionTypes.GET_EXAM_DETAILS,
		payload: { data },
	};
}

export function getExamDetailsSuccess(data) {
	return {
		type: examDetailsActionTypes.GET_EXAM_DETAILS_SUCCESS,
		payload: { data },
	};
}

export function getExamDetailsError() {
	return {
		type: examDetailsActionTypes.GET_EXAM_DETAILS_ERROR,
	};
}

export function cleanExamDetailsState() {
	return {
		type: examDetailsActionTypes.CLEAN_EXAM_DETAILS_STATE,
	};
}
